import getFocusableElements from './getFocusableElements';

const getLastFocusableElement = (parentElement, options) => {
  const focusableElements = getFocusableElements(parentElement, options);

  if (focusableElements.length) {
    return focusableElements[focusableElements.length - 1];
  }

  return null;
};

export default getLastFocusableElement;
